import AppPopover from "@/components/AppPopover";
import AppIcon from "@/components/AppIcon";
export default {
  name: "PpcBABlockCell",
  emits: ["block-toggled"],
  components: {
    AppIcon,
    AppPopover
  },
  props: {
    is_blocked: {
      type: Boolean,
      default: false
    },
    item_id: {
      type: String,
      default: ""
    },
    campaign_group_state: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      blockIconOver: false,
      popoverMap: {
        true: {
          title: "Unblock this product group",
          description: "It will become eligible for activation in the next algorithm run."
        },
        false: {
          title: "Block this product group",
          description: "It will be excluded from activation in the next algorithm run."
        }
      }
    };
  },
  computed: {
    getBlockIconColor() {
      return this.is_blocked ? this.campaign_group_state ? "#FF8F94" : "#DB333B" : this.blockIconOver ? "#F07A80" : "#C9CFD4";
    }
  }
};